<template>
    <div>
        <Form inline label-position="left" :label-width="0"  >
            <Row :gutter="10">
                <Col :xs="24" :sm="24" :md="12" :lg="8">
                    <FormItem  style="width:100%">
                        <Input v-model="searchItem.param" style="width:100%" placeholder="请输入关键词"></Input>
                    </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="12" :lg="1">
                    <Button type="primary" @click="getData()"><!-- 检索 -->{{$t('Search')}}</Button>
                </Col>
            </Row>
        </Form> 
        <Table border :loading="loading" :columns="columns" :data="data" >
            <template slot="action" slot-scope="{ row, index }">
                <Button size="small" @click="download(row,index)"><!-- 下载 -->{{$t('download')}}</Button>
            </template>
        </Table>
        <div style="display: flex;justify-content: space-between;margin-top: 30px;" >
        <Page :total="total" :current="pageInfo.pageNo" transfer :page-size="pageInfo.pageSize" @on-change="pageChange" :page-size-opts="[10,50,100,150]" show-sizer @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from '@/util/DateUtil'
export default {
    data(){
        return{
            date:new DateUtil(),
            searchItem:{},
            modalShow:false,
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[]
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('File_Name'),/* 文件名称 */
                    key: "resourceName",
                    align: "center",
                    minWidth:300
                },
                {
                    title: this.$t('Page_Name'),/* 页面名称 */
                    key: "page",
                    align: "center",
                    minWidth:300
                },{
                    title: this.$t('File_Admin'),/* 管理员 */
                    key: "adminUserName",
                    align: "center",
                    minWidth:200
                },{
                    title: this.$t('Action'),/* 操作 */
                    slot: "action",
                    align: "center",
                    minWidth:120
                }
            ]
        }
    },
     created(){
        this.getData()
    },
    methods:{
        getData(){
            this.loading=true
            axios.post("/carlsbergFile/selectCarlsbergFileList", {...this.pageInfo,...this.searchItem}).then((res) => {
                this.loading=false
                if(res){
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val;
            this.getData()
        },
        pageSizeChange(val){
            this.pageInfo.pageSize=val
            this.getData()
        },
        download(row,index){
            this.$donwLoad(row.resourceId);
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/index/CarlsbergFile.vue